import { HStack, Icon, Box, IconButton, Card, CardBody } from '@cad-arc';
import { agencyTypeIconNames } from '../../common/helpers/agency-type';
import { AgencyTypeGlobal } from '../../common/global-attributes';
import { BoloAutocompleteView, EventAutocompleteView } from '@mark43/cad-api';

interface SelectedEntityCardProps {
    field: BoloAutocompleteView | EventAutocompleteView;
    onRemove: () => void;
}

export const SelectedEntityCard = ({ field, onRemove }: SelectedEntityCardProps) => {
    const isEventView = (field: any): field is EventAutocompleteView => {
        return !!field['agencyTypeGlobalAttrId'];
    };

    const getCardContent = (field: EventAutocompleteView | BoloAutocompleteView) => {
        if (isEventView(field)) {
            return `${field.agencyEventNumber} ${field.cfsNumberAndText}`;
        }

        return field.title;
    };

    const getCardIcon = (field: EventAutocompleteView | BoloAutocompleteView) => {
        if (isEventView(field)) {
            return agencyTypeIconNames[field.agencyTypeGlobalAttrId as AgencyTypeGlobal];
        }

        return 'Bolo';
    };

    return (
        <Card>
            <CardBody style={{ padding: 'var(--arc-space-2)' }}>
                <HStack justifyContent="space-between">
                    <Icon icon={getCardIcon(field)} />
                    <Box flexGrow={1}>{getCardContent(field)}</Box>
                    <IconButton
                        icon="CloseX"
                        aria-label="Remove"
                        onClick={onRemove}
                        variant="ghost"
                    />
                </HStack>
            </CardBody>
        </Card>
    );
};
